export const fetchTotalHits = async ({
  baseUrl,
  siteId,
  filters,
  testFlag = false,
}) => {
  let url = `${baseUrl}/api/total-hits`;
  if (testFlag) {
    url = `${url}&test=${testFlag}`;
  }
  return fetch(url, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ filters, siteId }),
  }).then((response) => {
    if (response.status >= 400) {
      throw new Error(
        `Bad response from server while fetching total hits for VacationFinder. Filters: ${JSON.stringify.filters}`,
      );
    }
    return response.json();
  });
};